// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: facilityCrud.js
// Description: This file is responsible for SignIn Page
//
// ************************************************************************************************************************************************************
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { makeStyles, Typography } from "@material-ui/core";
import Surgeon from "../../../../icons/Surgeon.png";
import Admin from "../../../../icons/Admin.PNG";
import GEM from "../../../../icons/GEM.png";
import * as Yup from "yup";
import { useOktaAuth } from "@okta/okta-react";
import * as auth from "../_redux/authRedux";
import "../../../../App.css";
import { Form } from "react-bootstrap";
// import Surgeon from "../../../../icons/Surgeon.svg";
import "./Css/Login.css";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 6)
  },
  mt: {
    marginTop: "20px"
  },
  formControl: {
    margin: theme.spacing(1)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  btnClr: {
    backgroundColor: "#f5823d",
    borderColor: "#f5823d",
    "&:hover": {
      backgroundColor: "#f5823d",
      color: "#ffff"
    },
    color: "#ffff"
  },
  alertMsg: {
    color: "red"
  }
}));

let initialValues = {
  email: ""
};

function Login(props) {
  const { oktaAuth } = useOktaAuth();
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
  });
  const classes = useStyles();
  const enableLoading = () => {
    setLoading(true);
  };
  const disableLoading = () => {
    setLoading(false);
  };
  const disableMessage = () => {
    setResponse(false);
  };
  const enableMessage = () => {
    setResponse(true);
  };
  var text;
  useEffect(() => {}, []);
  if (localStorage.getItem("Logout")) {
    text = localStorage.getItem("Logout");
    setTimeout(() => {
      localStorage.removeItem("Logout");
    }, []);
  }

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      disableMessage();
      oktaAuth
        .signInWithRedirect()
        .then((res) => {
          // disableLoading();
          // if (res.status==="SUCCESS") {
          //   const sessionToken = res.sessionToken;
          //   oktaAuth.signInWithRedirect({ sessionToken });
          // }else {
          //   enableMessage();
          //   setMessage("Login Failed");
          // }
          // if (rememberMail===true) {
          //       Cookies.set('email',values.email)
          //     }else{
          //       Cookies.set('email','')
          //     }
        })
        .catch((error) => {
          disableLoading();
          setSubmitting(false);
          enableMessage();
          setMessage(error.errorSummary);
        });
    }
  });

  return (
    <div className="login-screen">
      <div className="image-section">
        <img src={Surgeon} style={{ width: "100%", height: "100%" }} alt="Surgeon"></img>
      </div>

      {/*<div className="image-section"></div>*/}
      <div className="login-section">
        <div
          className="row logo"
          style={{ marginTop: "30%", marginBottom: "122px" }}
        >
          <div className="cell">
            <Typography
              className="font_family"
              variant="h1"
              component="div"
              style={{
                flexGrow: 1,
                color: "#145898",
                fontStyle: "italic",
                fontSize: "3rem"
              }}
            >
              <img src={Admin} style={{ height: "84%", width: "73%" }} alt = "Admin"></img>
            </Typography>
          </div>
        </div>
        <img
          src={GEM}
          alt="GEM"
          style={{
            top: "280px",
            left: "600px",
            width: "333px",
            height: "px",
            position: "absolute"
          }}
        ></img>
        <div className="row nav">
          <div className="cell">
            {/*<img src={Admin} style={{ height: "84%", width: "73%" }} />*/}
          </div>
        </div>
        <div style={{ marginBottom: "303px", fontSize: "20px" }}>
          <Form style={{ width: "100%" }} onSubmit={formik.handleSubmit}>
            <div align="center" style={{ width: "72%" }}>
              <button
                className="btn btn-lg btn-block vertical-center"
                style={{
                  height: "55px",
                  bottom: "200px",
                  position: "absolute",
                  background: "#17BCB7",
                  borderRadius: "29.2308px",
                  fontSize: "20px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans Display"
                }}
                type="submit"
              >
                Sign in
                {loading && <span className="ml-3 spinner spinner-dark"></span>}
              </button>
            </div>
            <div className="row nav">
              <div className="cell" style={{ paddingTop: "50%" }}>
                {/*<img src={Synovis} style={{ height: "100%", width: "60%" }} />*/}
              </div>
            </div>
            {/* <div>
              <p>
                <Link to="/auth/forgot-password" style={{ color: "black" }}>
                  <u style={{ cursor: "pointer", fontSize: "90%" }}>
                    Forgot Password?
                  </u>
                </Link>
              </p>
              </div>*/}
            {responseStatus ? (
              <div className={`d-flex p-2 ${classes.alertMsg}`}>{errorMsg}</div>
            ) : (
              ""
            )}
            <div style={{ color: "red" }}>{text}</div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default connect(auth.reducer, auth.actions)(Login);
